// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Theme tokens used by all authenticated screens and portal tooltips. */
:root{--tooltip-bg:#252d40;--tooltip-border:#48536b;--tooltip-text:#f1f5f9}
html[data-theme="dark"]{color-scheme:dark}
:root {
  --bg-primary: #0a0e1a;
  --bg-secondary: #111827;
  --bg-card: #1a2035;
  --bg-card-hover: #1f2847;
  --bg-sidebar: #0d1220;
  --bg-input: #151c2e;

  --text-primary: #f0f2f5;
  --text-secondary: #8b95a8;
  --text-muted: #5a6478;

  --accent: #6366f1;
  --accent-hover: #818cf8;
  --accent-soft: rgba(99, 102, 241, 0.12);

  --success: #10b981;
  --success-soft: rgba(16, 185, 129, 0.12);
  --warning: #f59e0b;
  --warning-soft: rgba(245, 158, 11, 0.12);
  --danger: #ef4444;
  --danger-soft: rgba(239, 68, 68, 0.12);

  --border: #1e293b;
  --border-light: #2a3548;

  --radius: 10px;
  --radius-sm: 6px;
  --radius-lg: 16px;

  --shadow: 0 4px 24px rgba(0, 0, 0, 0.25);
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.2);

  --sidebar-width: 260px;

  --font-sans: 'DM Sans', -apple-system, sans-serif;
  --font-mono: 'JetBrains Mono', monospace;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-sans);
  background: var(--bg-primary);
  color: var(--text-primary);
  -webkit-font-smoothing: antialiased;
}

a { color: var(--accent); text-decoration: none; }
a:hover { color: var(--accent-hover); }


::-webkit-scrollbar { width: 6px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: var(--border-light); border-radius: 3px; }


@keyframes fadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes slideIn {
  from { opacity: 0; transform: translateX(-12px); }
  to { opacity: 1; transform: translateX(0); }
}

.animate-in {
  animation: fadeIn 0.3s ease-out;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.spin {
  animation: spin 1s linear infinite;
}
:root{--primary:var(--accent);--bg-hover:var(--bg-card-hover);--text-caption:#9ca3af;--trend-positive:#22c55e}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE,MAAM,oBAAoB,CAAC,wBAAwB,CAAC,sBAAsB;AAC1E,wBAAwB,iBAAiB;AACzC;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;;EAEnB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,iBAAiB;EACjB,uBAAuB;EACvB,uCAAuC;;EAEvC,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,sCAAsC;;EAEtC,iBAAiB;EACjB,uBAAuB;;EAEvB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;;EAEjB,wCAAwC;EACxC,yCAAyC;;EAEzC,sBAAsB;;EAEtB,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA,IAAI,oBAAoB,EAAE,qBAAqB,EAAE;AACjD,UAAU,0BAA0B,EAAE;;;AAGtC,sBAAsB,UAAU,EAAE;AAClC,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,+BAA+B,EAAE,kBAAkB,EAAE;;;AAGjF;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kCAAkC;AACpC;AACA,MAAM,uBAAuB,CAAC,+BAA+B,CAAC,sBAAsB,CAAC,wBAAwB","sourcesContent":["/* Theme tokens used by all authenticated screens and portal tooltips. */\n:root{--tooltip-bg:#252d40;--tooltip-border:#48536b;--tooltip-text:#f1f5f9}\nhtml[data-theme=\"dark\"]{color-scheme:dark}\n:root {\n  --bg-primary: #0a0e1a;\n  --bg-secondary: #111827;\n  --bg-card: #1a2035;\n  --bg-card-hover: #1f2847;\n  --bg-sidebar: #0d1220;\n  --bg-input: #151c2e;\n\n  --text-primary: #f0f2f5;\n  --text-secondary: #8b95a8;\n  --text-muted: #5a6478;\n\n  --accent: #6366f1;\n  --accent-hover: #818cf8;\n  --accent-soft: rgba(99, 102, 241, 0.12);\n\n  --success: #10b981;\n  --success-soft: rgba(16, 185, 129, 0.12);\n  --warning: #f59e0b;\n  --warning-soft: rgba(245, 158, 11, 0.12);\n  --danger: #ef4444;\n  --danger-soft: rgba(239, 68, 68, 0.12);\n\n  --border: #1e293b;\n  --border-light: #2a3548;\n\n  --radius: 10px;\n  --radius-sm: 6px;\n  --radius-lg: 16px;\n\n  --shadow: 0 4px 24px rgba(0, 0, 0, 0.25);\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.2);\n\n  --sidebar-width: 260px;\n\n  --font-sans: 'DM Sans', -apple-system, sans-serif;\n  --font-mono: 'JetBrains Mono', monospace;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-sans);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  -webkit-font-smoothing: antialiased;\n}\n\na { color: var(--accent); text-decoration: none; }\na:hover { color: var(--accent-hover); }\n\n\n::-webkit-scrollbar { width: 6px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb { background: var(--border-light); border-radius: 3px; }\n\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes slideIn {\n  from { opacity: 0; transform: translateX(-12px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n.animate-in {\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.spin {\n  animation: spin 1s linear infinite;\n}\n:root{--primary:var(--accent);--bg-hover:var(--bg-card-hover);--text-caption:#9ca3af;--trend-positive:#22c55e}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
